<template>
    <div :id="`custom-${attachment.id}`">
        <div
            v-if="getIsGraph()"
            style="height: 120px;"
        >
            <template v-if="isGraph && graphData.length > 1">
                <trend
                    v-once
                    :stroke-width="2"
                    :data="graphData"
                    :gradient="['#ff8162','#ff8162']"
                    :height="120"
                    auto-draw
                    smooth
                />
            </template>
            <template v-else>
                <trend
                    :stroke-width="2"
                    :data="[1, 20, 18, 29, 10, 2, 29]"
                    :gradient="['#ddd','#ddd']"
                    :height="120"
                    smooth
                />
            </template>
        </div>
        <div v-else-if="attachment.data.customId === 2">
            <div class="pulse-container">
                <span class="pulse-button">Breathe</span>
            </div>
        </div>
        <div v-else-if="attachment.data.customId === 3">
            <div
                v-if="!wordCloud.length"
                class="html padded question"
            >
                <p style="min-height: 200px">Please answer the question above before continuing</p>
            </div>
            <div
                v-if="wordCloud.length"
                class="html padded question"
            >
                <p>Choose up to 3 words that describe how you feel</p>
            </div>
            <div class="wordcloud">
                <a
                    v-for="(word, index) in wordCloud"
                    :key="`w-${index}-${selection.length}`"
                    :class="selection.indexOf(index) !== -1 ? 'active' : ''"
                    href="#"
                    @click="addToSelection(index)"
                >{{ word }}</a>
            </div>
            <br><br>
        </div>
        <div v-else-if="attachment.data.customId === 4">
            <div class="html question">
                That's it!<br><br><br>
                <template v-if="user.day > 1">
                    Since your last check in, you have completed {{ trackerData.countSinceLast }} unit{{ (trackerData.countSinceLast === 0 || trackerData.countSinceLast > 1) ? 's' : '' }}.
                    <br><br>
                    <span
                        v-if="trackerData.countSinceLast > 4"
                        class="colored"
                        style="line-height: 33px"
                    >Well done!<br>Keep up the good work!</span>
                    <span
                        v-else
                        class="colored"
                        style="line-height: 33px"
                    >Try completing more units next week!<br></span>
                </template>
            </div>
        </div>
        <div v-else-if="attachment.data.customId === 5">
            <div class="html padded default">
                <img
                    :src="attachment5Result.imageUrl"
                    class="slideImg"
                >
                <h3>You Got: {{ attachment5Result.title }}</h3>
                <div>{{ attachment5Result.body }}</div>
            </div>
        </div>
        <div v-else-if="attachment.data.customId === 6">
            <div class="html padded default">
                <img
                    :src="attachment6Result.imageUrl"
                    class="slideImg"
                >
                <h3>You Got: {{ attachment6Result.title }}</h3>
                <div>{{ attachment6Result.body }}</div>
            </div>
        </div>
        <div v-else>
            <span>This custom module was not yet built</span>
        </div>
    </div>
</template>

<script>
// named renderCustomAttachement5Logic because the names change but the id's never will.
// customId 5 is in attachement 1234,
// that is on slide 1234, that is in unit 1234 that has the name and title.
import { renderCustomAttachement6Logic, renderCustomAttachement5Logic } from './customAttachementsLogic';
export default {
    props: ['attachment'],
    store: ['api', 'user', 'trackerData', 'threeWords', 'myValueTraits'],
    data () {
        return {
            isGraph: false,
            graphData: [],
            wordClouds: [
                [
                    'Fulfilled',
                    'Connected',
                    'Experimental',
                    'Energized',
                    'Curious',
                    'In love',
                    'Happy',
                    'Inspired',
                    'Excited',
                    'Adventurous',
                    'Active',
                    'Kinky',
                    'Playful',
                    'Desired',
                    'In sync',
                    'Giving'
                ],
                [
                    'Balanced',
                    'Satisfied',
                    'Present',
                    'Connected',
                    'Energized',
                    'Curious',
                    'In love',
                    'Open',
                    'Active',
                    'Playful',
                    'Attractive',
                    'Desired',
                    'Happy',
                    'Content',
                    'Enough',
                    'Pleasurable'
                ],
                [
                    'Satisfied',
                    'Busy',
                    'Unmotivated',
                    'Open',
                    'Low energy',
                    'A bit bored',
                    'Distracted',
                    'Curious',
                    'Predictable',
                    'Uninspired',
                    'Connected',
                    'Planned',
                    'Directionless',
                    'Low desire',
                    'Wanting more',
                    'Wanting less'
                ],
                [
                    'Turned off',
                    'Uninspired',
                    'Unwanted',
                    'Guilty',
                    'Distracted',
                    'Bored',
                    'Busy',
                    'Stressed',
                    'Frustrated',
                    'Unattractive',
                    'Low desire',
                    'Disconnected',
                    'Desensitized',
                    'Inauthentic',
                    'Low energy',
                    'Directionless',
                    'Disempowered',
                    'In pain',
                    'Sad'
                ],
                [
                    'Dry spell',
                    'Disconnected',
                    'Satisfied',
                    'Lonely',
                    'Distracted',
                    'Low priority',
                    'Unfulfilled',
                    'Unmotivated',
                    'Away from partner',
                    'Insecure',
                    'Unattractive',
                    'Misunderstood',
                    'Hopeless',
                    'Empowered',
                    'Busy',
                    'Stressed'
                ]
            ],
            wordCloud: [],
            selection: []
        };
    },
    computed: {
        // The value Traits are hardcoded in the CMS /traits
        // myValueTraits[1] will give us the answer of the trait nbr 1
        attachment5Result: function () {
            const { myValueTraits } = this;
            const categoriesWithScores = {
                performanceAnxiety: myValueTraits[88],
                desire: myValueTraits[87],
                sexSatisfaction: myValueTraits[90],
                sexFrequency: myValueTraits[89]
            };

            return renderCustomAttachement5Logic(categoriesWithScores);
        },
        attachment6Result: function () {
            const { myValueTraits } = this;
            const categoriesWithScores = {
                intense: myValueTraits[81],
                persistent: myValueTraits[82],
                adaptable: myValueTraits[84],
                sensitive: myValueTraits[83]
            };

            return renderCustomAttachement6Logic(categoriesWithScores);
        },

    },
    watch: {},
    mounted: function () {
        this.$events.fire('pulse-get');
        if (this.getIsGraph()) {
            this.$events.on(`refresh-custom-${this.attachment.data.customId}`, () => {
                this.getGraphData(this.attachment.data.customId);
            });
            this.getGraphData(this.attachment.data.customId);
        }
        if (this.attachment.data.customId) {
            this.threeWords = [];
            this.$events.on(`answer:1845`, e => {
                this.wordCloud = this.wordClouds[e.choiceInt];
                this.selection.length = 0;
                this.threeWords.length = 0;
            });
        }
    },
    beforeDestroy () {
        this.$events.off(`refresh-custom-${this.attachment.data.customId}`);
        this.$events.off(`answer:1845`);
    },
    methods: {
        addToSelection: function (index) {
            if (this.selection.indexOf(index) === -1) {
                this.selection.push(index);
                this.threeWords.push(this.wordCloud[index]);
            } else {
                this.selection.splice(this.selection.indexOf(index), 1);
                this.threeWords.splice(this.selection.indexOf(index), 1);
            }
            if (this.selection.length > 3) {
                this.selection.shift();
                this.threeWords.shift();
            }
        },
        getIsGraph: function () {
            return !!(['1'].indexOf(this.attachment.data.customId + '') > -1);
        },
        getGraphData: function (id) {
            this.$http.get(`${this.api}/results/graphData/${id}`).then(
                response => {
                    let graph = response.body.graph;
                    if (id === 1) {
                        // remove empty weeks from tracker
                        for (let i = 0; i < graph.length; i++) {
                            const element = graph[i];
                            if (!element) graph.splice(i, 1);
                        }
                        for (let i = 0; i < graph.length; i++) {
                            const element = graph[i];
                            if (!element) graph.splice(i, 1);
                        }
                        for (let i = 0; i < graph.length; i++) {
                            const element = graph[i];
                            if (!element) graph.splice(i, 1);
                        }
                    }
                    this.graphData = graph;
                    if (this.graphData[0]) this.graphData.unshift(this.graphData[0]);
                    this.isGraph = true;
                },
                () => {
                    console.error('Could not fetch graph datas');
                }
            );
        }
    }
};
</script>

<style lang="less" scoped>
@import '../../css/colors.less';
span {
    color: gray;
    padding: 10px;
    line-height: 44px;
}

.wordcloud {
    max-width: 400px;
    margin: 30px auto;
    text-align: center;
    a {
        font-family: AndesMedium;
        display: inline-block;
        cursor: pointer;
        margin: 7px 6px;
        font-size: 15px;
        text-transform: uppercase;
        padding: 5px 10px 3px;
        border-radius: 22px;
        border: 2px solid @coral;
        &.active {
            background: @coral;
            color: white;
        }
    }
}

.colored {
    color: @coral;
}

.pulse-container {
    width: 200px;
    height: 200px;
    margin: 20px auto 30px;
    perspective: 1000;
    backface-visibility: hidden;
    -webkit-perspective: 1000;
    -webkit-backface-visibility: hidden;
    background: #fff;
}

.pulse-button {
    position: relative;
    top: 50%;
    left: 50%;
    margin-left: -50px;
    margin-top: -50px;
    display: block;
    width: 100px;
    height: 100px;
    font-size: 1.3em;
    font-weight: light;
    font-family: AndesMedium;
    text-transform: uppercase;
    text-align: center;
    line-height: 85px;
    letter-spacing: -1px;
    color: white;
    border: none;
    border-radius: 50%;
    background: #fc6f65;
    cursor: pointer;
    box-shadow: 0 0 0 0 rgba(252, 111, 101, 0.5);
    animation: pulse 4.5s infinite;
    -webkit-animation: pulse 4.5s infinite;
}

@keyframes pulse {
    0% {
        -moz-transform: scale(0.9);
        -ms-transform: scale(0.9);
        -webkit-transform: scale(0.9);
        transform: scale(0.9);
    }
    70% {
        -moz-transform: scale(1);
        -ms-transform: scale(1);
        -webkit-transform: scale(1);
        transform: scale(1);
        box-shadow: 0 0 0 50px rgba(252, 111, 101, 0);
    }
    100% {
        -moz-transform: scale(0.9);
        -ms-transform: scale(0.9);
        -webkit-transform: scale(0.9);
        transform: scale(0.9);
        box-shadow: 0 0 0 0 rgba(252, 111, 101, 0);
    }
}
@-webkit-keyframes pulse {
    0% {
        -moz-transform: scale(0.9);
        -ms-transform: scale(0.9);
        -webkit-transform: scale(0.9);
        transform: scale(0.9);
    }
    70% {
        -moz-transform: scale(1);
        -ms-transform: scale(1);
        -webkit-transform: scale(1);
        transform: scale(1);
        box-shadow: 0 0 0 50px rgba(252, 111, 101, 0);
    }
    100% {
        -moz-transform: scale(0.9);
        -ms-transform: scale(0.9);
        -webkit-transform: scale(0.9);
        transform: scale(0.9);
        box-shadow: 0 0 0 0 rgba(252, 111, 101, 0);
    }
}
</style>
